<template>
  <div class="content md flex-box" v-if="activity">
    <data-list
      ref="dataList"
      class="flex-grow"
      url="/activity/activity-article"
      entity-name="文章"
      add-btn="添加文章"
      hide-show-detail
      :before-update="beforeUpdate"
      :query="query"
      :action="action"
      :columns="columns"
      :rules="rules"
      :modalWidth="modalWidth"
      :searchKeyType="searchKeyType"
    >
      <template v-slot:query="{ form }">
        <a-form-model-item label="">
          <a-input
            v-model="form.title"
            placeholder="输入文章名称查询"
          ></a-input>
        </a-form-model-item>
      </template>
      <template v-slot:action="{ item }">
        <a class="txt-btn" @click="copyLink(item)">复制链接</a>
      </template>
      <template v-slot:edit="{ form }">
        <a-form-model-item label="排版方式" prop="type">
          <a-select v-model="form.type" :options="options" placeholder="请选择文章内容排版方式"></a-select>
        </a-form-model-item>
        <a-form-model-item label="文章标题" prop="title">
          <a-input v-model="form.title" placeholder="请输入文章标题"></a-input>
        </a-form-model-item>
        <a-form-model-item label="文章英文标题" prop="title_en">
          <a-input v-model="form.title_en" placeholder="请输入文章英文标题"></a-input>
        </a-form-model-item>
        <template v-if="form.type == 1">
          <a-form-model-item label="文章摘要" prop="desc">
            <a-input v-model="form.desc" placeholder="请输入文章摘要"></a-input>
          </a-form-model-item>
        </template>
        <a-form-model-item label="文章缩略图" prop="img">
          <form-upload v-model="form.img" :limit="1" />
        </a-form-model-item>
        <a-form-model-item label="文章内容" prop="content">
          <rich-editor v-model="form.content" />
        </a-form-model-item>
      </template>
    </data-list>
  </div>
</template>

<script>
import { copy } from "../../../common/js/tool";
import mixins from "../mixins";

export default {
  name: "ActivityArticle",
  data() {
    return {
      modalWidth: 600,
      searchKeyType: {
        title: 1,
      },
      options: [
          { key: 1, title: "正常排版" },
          { key: 2, title: "只显示内容" },
      ],
      columns: [
        { title: "文章标题", dataIndex: "title" },
        { title: "创建时间", dataIndex: "create_time" },
        { title: "更新时间", dataIndex: "update_time" },
      ],
      rules: {
        type: [{ required: true, message: "请选择文章内容排版方式", trigger: "change" }],
        title: [{ required: true, message: "请输入文章标题", trigger: "blur" }],
        title_en: [{ required: true, message: "请输入文章英文标题", trigger: "blur" }],
        desc: [{ required: false, message: "请输入文章摘要", trigger: "blur" }],
        img: [{ required: true, message: "请选择图片", trigger: "change" }],
        content: [
          { required: true, message: "请输入文章内容", trigger: "blur" },
        ],
      },
      moduleKey: 'furnish-article'
    };
  },
  mixins: [mixins],
  computed: {
    action() {
      return this.editable ? ['add', 'delete', 'update', 'query', 'audit'] : ['query'];
    },
    activity() {
      return this.$store.getters.activity;
    },
    query() {
      let res = "";
      const activity = this.activity;
      if (activity) {
        res += `&filter[activity_id]=${activity.id}`;
      }
      return res;
    },
  },
  methods: {
    beforeUpdate(form, fn) {
      if (!form.id) {
        form.activity_id = this.activity.id;
      }
      fn();
    },
    copyLink(item) {
      // TODO
      let url = `http://m.qihe.live/meeting/${this.activity.alias}/article/${item.id}`;
      copy(url);
    },
  },
};
</script>

<style lang="less" scoped></style>
